import { render, staticRenderFns } from "./LeadTabs.vue?vue&type=template&id=37560b04&scoped=true"
import script from "./LeadTabs.vue?vue&type=script&lang=js"
export * from "./LeadTabs.vue?vue&type=script&lang=js"
import style0 from "./LeadTabs.vue?vue&type=style&index=0&id=37560b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37560b04",
  null
  
)

export default component.exports